export default __webpack_public_path__ + "static/media/homer4.bdc6576e.png";